<template>
  <div class="pa-3">
    <div v-if="isOuternetHeatmapViewer" class="d-flex justify-end mb-2">
      <v-btn small text color="primary" @click="signOut">Sign out</v-btn>
    </div>
    <v-card outlined class="mb-3">
      <v-card-text class="py-3">
        <div class="d-flex justify-space-between align-center flex-wrap">
          <div>
            <div class="subtitle-1 font-weight-bold">Outernet Heatmap Dashboard</div>
            <div class="caption grey--text text--darken-1">
              Track billboard concentration, quality, and campaign spread by location.
            </div>
          </div>
          <div class="d-flex align-center mt-2 mt-md-0">
            <v-chip small color="grey lighten-3" class="mr-2">
              {{ submissions.length }} submissions
            </v-chip>
            <v-btn small color="primary" outlined @click="getSharedSubmissions">
              Refresh
            </v-btn>
          </div>
        </div>
        <div v-if="lastUpdated" class="caption grey--text text--darken-1 mt-2">
          Last updated: {{ lastUpdated }}
        </div>
      </v-card-text>
    </v-card>

    <v-alert v-if="error" type="error" dense outlined class="mb-3">
      {{ error }}
    </v-alert>

    <v-alert
      v-else-if="!submissions.length"
      type="info"
      dense
      outlined
      class="mb-3"
    >
      No billboard submissions available to visualize yet.
    </v-alert>

    <HeatmapView
      v-else
      :key="heatmapMountKey"
      :data="submissions"
      :total-unique-users="totalUniqueUsers"
      :hide-user-submission-insights="isOuternetHeatmapViewer"
      :hide-unique-user-insight-metrics="isOuternetHeatmapViewer"
    />
  </div>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2.js";
const service = new RestResource();
import HeatmapView from "../../../components/HeatMap.vue";
import { ROLE_OUTERNET_HEATMAP_VIEWER } from "@/constants/authRoles";

export default {
  components: {
    HeatmapView,
  },
  computed: {
    isOuternetHeatmapViewer() {
      return this.$store.state.loggedInAs === ROLE_OUTERNET_HEATMAP_VIEWER;
    },
  },
  data() {
    return {
      submissions: [],
      totalUniqueUsers: 0,
      error: "",
      lastUpdated: "",
      heatmapMountKey: 0,
    };
  },

  mounted() {
    this.getSharedSubmissions();
  },

  methods: {
    signOut() {
      if (window.getApp) {
        window.getApp.$emit("APP_LOGOUT");
      }
    },
    async getSharedSubmissions() {
      this.$setLoader();
      try {
        const res = await service.getAllOuternetSubmissions();
        this.submissions = res.data.data || [];
        this.totalUniqueUsers = this.extractTotalUniqueUsers(res);
        this.lastUpdated = new Date().toLocaleString();
        this.error = "";
        this.heatmapMountKey += 1;
      } catch (err) {
        this.error =
          err.response?.data?.error || "Failed to fetch submissions.";
      } finally {
        this.$disableLoader();
      }
    },
    extractTotalUniqueUsers(res) {
      const body = (res && res.data) || {};
      const candidates = [
        body.totalUniqueUsers,
        body.meta && body.meta.totalUniqueUsers,
        body.data && body.data.totalUniqueUsers,
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const value = Number(candidates[i]);
        if (Number.isFinite(value) && value >= 0) {
          return value;
        }
      }
      return 0;
    },
  },
};
</script>
